import React from 'react';
import { Box, Chip, IconButton, Tooltip, Typography } from '@mui/material';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';

export default function DiffLine({ line, comments = [], onFixRequest, onMarkIntentional, fixedLine = false, stagedIds = new Set(), stagedIntentionalIds = new Set(), intentionalLine = false, canFix = true, renderCommentItem }) {
  const isAddition = line.type === 'added';
  const isDeletion = line.type === 'removed';
  const lineHasUnfixedIssue = (comments || []).some(c => !((c.body || '').toString().toLowerCase().includes('fixed - ')));
  const isIssue = intentionalLine ? false : lineHasUnfixedIssue;
  const isFixed = !!fixedLine;
  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', fontFamily: 'ui-monospace, SFMono-Regular, "SF Mono", Consolas, "Liberation Mono", Menlo, monospace', fontSize: '12px', lineHeight: 1.5, backgroundColor: intentionalLine ? '#5a4b00' : (isIssue ? '#3d2e00' : (isAddition ? '#102a17' : isDeletion ? '#3b0a10' : '#0d1117')), borderLeft: `4px solid ${intentionalLine ? '#f0ad36' : (isIssue ? '#f0883e' : (isAddition ? '#238636' : isDeletion ? '#da3633' : '#30363d'))}`, '&:hover': { backgroundColor: isIssue ? '#3a2600' : (isAddition ? '#0a3d22' : isDeletion ? '#4d0a0f' : '#161b22') } }}>
      <Box sx={{ minWidth: '60px', p: '4px 8px', textAlign: 'right', color: '#7d8590', borderRight: '1px solid #30363d', backgroundColor: '#161b22', userSelect: 'none' }}>{line.line_number}</Box>
      <Box sx={{ p: '4px 8px', flex: 1, color: intentionalLine ? '#ffd58a' : (isIssue ? '#ffa657' : (isAddition ? '#7ee787' : isDeletion ? '#ff7b72' : '#f0f6fc')), whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
          <Box sx={{ flex: 1 }}>{line.content}</Box>
          {isFixed && (<Typography variant="caption" sx={{ color: '#7ee787', fontWeight: 700 }}>F</Typography>)}
          {intentionalLine && (<Chip label="i" size="small" sx={{ ml: 0.5, height: 18, minWidth: 18, borderRadius: '10px', fontSize: '10px', lineHeight: 1, px: 0.5, backgroundColor: '#3d2e00', color: '#ffa657', border: '1px solid #f0ad36' }} />)}
          {comments.length > 0 && (
            <Tooltip title={`${comments.length} comment${comments.length > 1 ? 's' : ''}`}>
              <IconButton size="small" sx={{ color: '#58a6ff', '&:hover': { backgroundColor: '#58a6ff20' } }}>
                <ChatBubbleOutlineIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </Box>
        {comments.map((comment, index) => {
          const tidRaw = (comment && (comment.thread_id ?? comment.threadId ?? comment.ThreadID));
          const cid = typeof tidRaw === 'string' ? parseInt(tidRaw, 10) : tidRaw;
          const alreadyFixed = (comment.body || '').toString().toLowerCase().includes('fixed - ');
          const committedIntentional = (comment.body || '').toString().toLowerCase().includes('marked intentional - ');
          const stagedDisabled = Number.isFinite(cid) && stagedIds instanceof Set && stagedIds.has(cid);
          const isIntentionalStaged = Number.isFinite(cid) && stagedIntentionalIds instanceof Set && stagedIntentionalIds.has(cid);
          return (
            <React.Fragment key={index}>
              {typeof renderCommentItem === 'function' ? renderCommentItem({ comment, onFixRequest, onMarkIntentional, line, disableFix: (!canFix || alreadyFixed || committedIntentional), fixApplied: stagedDisabled, intentionalStaged: (isIntentionalStaged || committedIntentional) }) : null}
            </React.Fragment>
          );
        })}
      </Box>
    </Box>
  );
}




